import { wealthProApi } from '../../redux/api';
import _ from "lodash";
import { useCacheKeyMergeHandler, useCacheKeySerializeQueryArgsHandler, useCacheKeyTransformResponseHandler } from "../../redux/helpers";

const hoAdminDebtorsApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["applicationDebtors", "applicationAgedDebtors"]
}).injectEndpoints({
    endpoints: (builder) => ({
        agedDebtors: builder.query({
            //query: ({ data }) => ({
            query: ({filter}) => ({
                url: `api/headofficeadmin/debtors/ageddebtors`,
                method: "POST",
                body: filter
            }),
            providesTags: ["applicationAgedDebtors"]
        }),
        agedDebtorsDetail: builder.query({
            query: (data) => ({
            //query: (data) => ({
                url: `api/headofficeadmin/debtors/ageddebtorsdetail`,
                method: "POST",
                body: data
            }),
            //transformResponse: (response, _, { cacheKey }) => {
                //return { cacheKey, ...response };
            //},
            //11/07 
            //serializeQueryArgs: useCacheKeySerializeQueryArgsHandler,
            //merge: useCacheKeyMergeHandler,
            //transformResponse: useCacheKeyTransformResponseHandler
            //11/07
            serializeQueryArgs: ({endpointName}) => {
                return endpointName;
            },
            merge: (currentCache, newItems) => {
                const { pagination: currPage } = currentCache || {};
                const { pagination: nextPage } = newItems || {};
                
                if (!currPage || nextPage.page <= currPage.page) {
                    return newItems;
                }

                currentCache.pagination = newItems.pagination;
                currentCache.results.push(...newItems.results);
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                const { page: currPage } = currentArg || { page: 1 };
                const { page: prevPage } = previousArg || { page: 0 };
                return currPage !== prevPage;
            },
            providesTags: ["applicationAgedDebtorDetails"]
        }),
        archiveDebtors: builder.mutation({
            query: (theArchiveDate, fromDate, toDate) => ({
                url: `api/headofficeadmin/debtors/archivedebtors`,
                method: "POST",
                body: (theArchiveDate)

            }),
            async onQueryStarted({ fromDate,toDate }, { dispatch, queryFulfilled }) {
                //TODO doesn't seem to be hitting server with correct from and to
                //dispatch(wealthProApi.util.updateQueryData('ageddebtors', (fromDate,toDate), (results) => {
                dispatch(wealthProApi.util.updateQueryData('ageddebtors', {}, (results) => {
                        return {...results};
                    }));
                    try {
                        await queryFulfilled;
                    }
                    catch {
                        
                    }

            },
            invalidatesTags: ['applicationAgedDebtors']
        }),
        searchDebtors: builder.query({
            query: ({filter}) => ({
                //url: `api/headofficeadmin/debtors/searchdebtors`,
                url: `api/headofficeadmin/debtors/search`,
                method: "POST",
                body: filter
            }),
            transformResponse: (response, _, { cacheKey }) => {
                                return { cacheKey, ...response };
            },
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return endpointName;
            },
            merge: (currentCache, newItems) => {
                if (_.isEqual(currentCache.cacheKey, newItems.cacheKey)) {
                    currentCache.pagination = newItems.pagination;
                    currentCache.hasMore = newItems.hasMore;
                    currentCache.results.push(...newItems.results);
                }
                else {
                    currentCache.cacheKey = newItems.cacheKey;
                    currentCache.pagination = newItems.pagination;
                    currentCache.results = [...newItems.results];
                    currentCache.hasMore = newItems.hasMore;
                }             
            }
            //merge: (currentCache, newItems) => {
                //const { pagination: { page: currPage } } = currentCache || {};
                //const { pagination: { page: nextPage }, hasMore } = newItems || {};

                //if (!currPage || nextPage <= currPage) {
                    //return newItems;
                //}

                //currentCache.hasMore = newItems.hasMore;
                //currentCache.pagination = newItems.pagination;
                //currentCache.results.push(...newItems.results);
            //},
            //forceRefetch: ({ currentArg, previousArg }) => {
                //const { pagination: { page: currPage }, userId: currUserId } = currentArg || { pagination: { page: 1 }, userId: null };
                //const { pagination: { page: prevPage }, userId: prevUserId } = previousArg || { pagination: { page: 0 }, userId: null };
                //return currPage !== prevPage || currUserId !== prevUserId;
            //},
        }),
        searchDebtorTotals: builder.query({
            query: ({filter}) => ({
                url: `api/headofficeadmin/debtors/search/totals`,
                method: 'POST',
                body: filter
            }),
            providesTags: ['applicationDebtors']
        })
    }),   
});

export const {
    useLazyAgedDebtorsQuery,
    useAgedDebtorsQuery,
    useLazyAgedDebtorsDetailQuery,
    useLazySearchDebtorsQuery,
    useSearchDebtorTotalsQuery,
    useLazySearchDebtorTotalsQuery,
    useArchiveDebtorsMutation
} = hoAdminDebtorsApiEndpoints;